import { i18n } from "../../i18n";
import { PrimaryButton } from "../Buttons/PrimaryButton";
import { closeModal } from "./Modal";

export const DutiesAndTaxesModalContent = () => {
  return (
    <>
      <article className="tw:px-4">
        <h2>{i18n("modal.duties-and-taxes.title")}</h2>
        <p>{i18n("modal.duties-and-taxes.description.one")}</p>
        <p>{i18n("modal.duties-and-taxes.description.two")}</p>
        <span className="tw:block tw:h-px tw:bg-fruugo-border-control tw:w-full tw:mb-4"></span>
        <h3 className="tw:text-lg tw:font-bold">
          {i18n("modal.duties-and-taxes.vat.title")}
        </h3>
        <p className="tw:mb-0">
          {i18n("modal.duties-and-taxes.vat.description")}
        </p>
        <ul>
          <li>{i18n("modal.duties-and-taxes.vat.list.one")}</li>
          <li>{i18n("modal.duties-and-taxes.vat.list.two")}</li>
          <li>{i18n("modal.duties-and-taxes.vat.list.three")}</li>
        </ul>
        <span className="tw:block tw:h-px tw:bg-fruugo-border-control tw:w-full tw:mb-4"></span>
        <h3 className="tw:text-lg tw:font-bold">
          {i18n("modal.duties-and-taxes.customs-duties.title")}
        </h3>
        <p className="tw:mb-0">
          {i18n("modal.duties-and-taxes.customs-duties.description")}
        </p>
        <ul>
          <li>{i18n("modal.duties-and-taxes.customs-duties.list.one")}</li>
          <li>{i18n("modal.duties-and-taxes.customs-duties.list.two")}</li>
          <li>{i18n("modal.duties-and-taxes.customs-duties.list.three")}</li>
          <li>{i18n("modal.duties-and-taxes.customs-duties.list.four")}</li>
        </ul>
        <span className="tw:block tw:h-px tw:bg-fruugo-border-control tw:w-full tw:mb-4"></span>
        <h3 className="tw:text-lg tw:font-bold">
          {i18n("modal.duties-and-taxes.handling-fees.title")}
        </h3>
        <p className="tw:mb-0">
          {i18n("modal.duties-and-taxes.handling-fees.description")}
        </p>
        <ul>
          <li>{i18n("modal.duties-and-taxes.handling-fees.list.one")}</li>
          <li>{i18n("modal.duties-and-taxes.handling-fees.list.two")}</li>
          <li>{i18n("modal.duties-and-taxes.handling-fees.list.three")}</li>
        </ul>
        <span className="tw:block tw:h-px tw:bg-fruugo-border-control tw:w-full tw:mb-4"></span>
        <p
          dangerouslySetInnerHTML={{
            __html: i18n("modal.duties-and-taxes.description.three"),
          }}
        ></p>
        <p>{i18n("modal.duties-and-taxes.description.four")}</p>
        <a
          href="/help/detail/customs-charge"
          target="_blank"
          className="tw:underline tw:hover:no-underline tw:focus-within:ring-2 tw:focus-within:ring-offset-2 tw:focus-visible:ring-fruugo-blue-secondary"
        >
          {i18n("modal.duties-and-taxes.link")}
        </a>
      </article>
      <footer className="tw:bg-white tw:border-none tw:text-right tw:p-4 tw:rtl:text-left">
        <PrimaryButton onClick={() => closeModal()} variant="solid">
          {i18n("modal.duties-and-taxes.button")}
        </PrimaryButton>
      </footer>
    </>
  );
};
